import React, { useEffect, useRef } from "react";
import Highcharts, { Options } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { AvgBarleyWheatChart } from "../../../redux/actions/dashboard/dashboardTypes";

interface VarietyRateChartProps {
  avgProtWheat: AvgBarleyWheatChart[];
  t: (arg0: string) => string;
  loading: boolean;
}

const VarietyRateChart: React.FC<VarietyRateChartProps> = ({
  avgProtWheat,
  t,
  loading,
}) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (chart) {
      if (loading) {
        chart.showLoading(`...${t("Common_options.Loading")}`);
      } else {
        chart.hideLoading();
      }
    }
  }, [loading, t]);
  const chartOptions: Options = {
    colors: ["#50B432", "#058DC7"],
    chart: {
      type: "column",
    },
    loading: {
      hideDuration: 300,
      showDuration: 300,
      labelStyle: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
      },
      style: {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
      },
    },
    title: {
      text: t("Dashboard.cereal_charts.protein_levels_variety"),
    },

    series: [
      {
        name: t("Dashboard.protein_rate"),
        data: avgProtWheat.map((u: any) => u.average),
      } as any,
    ],
    yAxis: {
      title: {
        text: "",
      },
    },
    xAxis: {
      categories: avgProtWheat.map((u: any) => u.variety),
    },
  };
  return (
    <HighchartsReact
      ref={chartRef}
      containerProps={{
        style: {
          width: "100%",
          marginBottom: "50px",
        },
      }}
      highcharts={Highcharts}
      options={chartOptions}
    />
  );
};

export default VarietyRateChart;
